import { type ReactNode } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { renderItems } from "./DesktopTechFilterCategory";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";
import type { TechFilter } from "~/Search/filterConfigModels";
import { useTechFilterReset } from "~/Search/components/Filters/TechFilterResetContext";

interface Props {
  image?: ReactNode;
  items: TechFilter[];
}

export const MobileTechFilterCategory = (props: Props) => {
  const { items, image } = props;
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { resetFilters } = useTechFilterReset();

  const techFilterCodes = items.map((item) => item.uid);

  // Watch values to determine if buttons should be enabled
  const allValues = useWatch({ control });
  const isClearEnabled = techFilterCodes.some(
    (uid) => allValues[uid]?.["min"] !== undefined || allValues[uid]?.["max"] !== undefined,
  );

  const { formState } = useFormContext();
  const isApplyEnabled = formState.isDirty;

  const onClearClick = () => {
    resetFilters(techFilterCodes);
  };

  const renderChildren = renderItems(items);

  return (
    <div className="scha__sa__tech-filter-category--mobile">
      {image}
      {renderChildren}
      <div className="scha__sa__tech-filter-category__actions--mobile">
        <Button disabled={!isClearEnabled} onClick={onClearClick} variant={"text"}>
          {t("searchPage.refinement.button.clear")}
        </Button>
        <Button disabled={!isApplyEnabled} type={"submit"}>
          {t("searchPage.refinement.button.apply")}
        </Button>
      </div>
    </div>
  );
};
